const KEYS = {
    WORKSHIFT_DATES: 'WORKSHIFT_DATES',
    MODAL_DATES: 'MODAL_DATES',
};

export const validationUsualSundays = KEYS.WORKSHIFT_DATES;
